export default "__VITE_ASSET__BTMXW2AF__"